import React from 'react';
import { useDeleteBuildingMutation } from '../../services/building';
import { Box, Button, Modal, Text } from '@ies-ds/react-ui';

const BuildingDelete = ({ id }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [deleteBuilding, { isError, isLoading, isSuccess }] = useDeleteBuildingMutation();

  return (
    <div>
      <Button color="default-primary" size="xsmall" onClick={() => setIsOpen(true)}>
        Delete
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <Modal.Header>
          <Text weight={'medium'} size="large">
            Delete building
          </Text>
        </Modal.Header>
        <Modal.Content>
          <Text weight="medium">Are you sure you want to delete this building?</Text>
          <br />
          <p>All floor and sensor data associated with the building will be permanently deleted as well!</p>
        </Modal.Content>

        <Modal.Footer>
          <Box gap={8}>
            <Button color="warning" onClick={() => deleteBuilding(id)}>
              Delete
            </Button>
            <Button onClick={() => setIsOpen(false)}>Cancel</Button>
          </Box>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BuildingDelete;
